import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  getService,
  setBetaWelcomeModal,
  setBootstrapApp,
  setUserBusinessUnits,
  setUserRoles,
  useAppDispatch,
  useAppSelector
} from 'app/redux';
import {
  Presentation,
  Footer,
  BusinessArea,
  Services,
  Flow,
  Example,
  LetsTry,
  Disclaimer
} from 'app/components';
import {
  IBusinessArea,
  IServices,
  isLastVersion,
  mapBusinessAreas,
  mapServices,
  mapFeatures,
  smoothScrollingToAnchor
} from 'app/utils';
import styles from './Landing.module.scss';
import { getBootstrap } from 'integration';
import config from 'config';
import { IFeature } from '../../app/utils/types';

export const LandingView: React.FC = () => {
  const dispatch = useAppDispatch();
  const currentService = useAppSelector(getService);
  const queryParameters = new URLSearchParams(window.location.search);
  const anchor = queryParameters.get('anchor');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBootstrap = async (): Promise<void> => {
      try {
        const response = await getBootstrap();
        dispatch(
          setBootstrapApp({
            services: mapServices(
              response?.services as IServices,
              response?.features as IFeature[]
            ),
            businessAreas: mapBusinessAreas(
              response?.businessAreas as IBusinessArea,
              response?.features as IFeature[]
            ),
            features: mapFeatures(response?.features)
          })
        );
        dispatch(setUserRoles(response?.roles?.permissions));
        dispatch(setUserBusinessUnits(response?.roles?.businessUnits));
      } catch (error: any) {
        if (error.message === 'NOT_WHITELISTED') {
          navigate(config.APP.PATH.FORBIDDEN);
        }
      }
    };

    if (anchor != null) smoothScrollingToAnchor(anchor);

    if (config.APP.FUNCTIONALITIES.SHOW_BETA_MODAL.toString() === 'true') {
      if (!isLastVersion() || localStorage.getItem('welcomeModal') === null) {
        dispatch(setBetaWelcomeModal(true));
      }
    }

    fetchBootstrap();
  }, []);

  return (
    <div className={styles.landing}>
      <Presentation />
      <BusinessArea />
      <Services />
      {currentService !== undefined && (
        <>
          <Flow service={currentService} />
          <Example service={currentService} />
        </>
      )}
      <LetsTry />
      <Footer />
      <Disclaimer />
    </div>
  );
};
